<div class="notifications-main-container" #notificationsMainWindow tabindex="-1" role="dialog" [attr.aria-modal]="true">
  <div class="notifications-list" #notificationsList>
    <div class="list-header">
      <div class="title">
        <h1>{{ 'IN_APP_NOTIFICATIONS.NOTIFICATIONS' | translate }}</h1>

        <button
          *ngIf="deviceInfo.deviceTypeDetected === 'PHONE'"
          class="mark-all-icon"
          type="button"
          [attr.aria-label]="'IN_APP_NOTIFICATIONS.MARK_ALL_AS_READ' | translate"
          (click)="markAllAsRead()">
          <mat-icon>done_all</mat-icon>
        </button>
      </div>

      <button
        *ngIf="deviceInfo.deviceTypeDetected === 'PHONE'"
        class="close-icon"
        type="button"
        (click)="closeNotifications.emit()"
        [attr.aria-label]="'COMMON.ACTION.CLOSE' | translate">
        <mat-icon>close</mat-icon>
      </button>

      <button
        *ngIf="deviceInfo.deviceTypeDetected !== 'PHONE'"
        class="mark-all"
        type="button"
        [attr.aria-label]="'IN_APP_NOTIFICATIONS.MARK_ALL_AS_READ' | translate"
        (click)="markAllAsRead()">
        {{ 'IN_APP_NOTIFICATIONS.MARK_ALL_AS_READ' | translate }}
      </button>
    </div>

    <div class="buttons-wrapper">
      <button
        class="standard-form-button"
        [class.button-toggled]="!showOnlyUnread"
        type="button"
        [attr.aria-pressed]="!showOnlyUnread"
        (click)="setShowOnlyUnread(false)">
        {{ 'IN_APP_NOTIFICATIONS.ALL' | translate }}
      </button>

      <button
        class="standard-form-button"
        [class.button-toggled]="showOnlyUnread"
        type="button"
        [attr.aria-pressed]="showOnlyUnread"
        (click)="setShowOnlyUnread(true)">
        {{ 'IN_APP_NOTIFICATIONS.UNREAD' | translate }}
      </button>
    </div>

    <div *ngIf="loading$ | async" class="loading-wrapper" role="status" aria-live="polite">
      <span class="sr-only">
        {{ 'COMMON.LAYOUT.LOADING' | translate }}
      </span>

      <mat-spinner [diameter]="55" [attr.aria-hidden]="true"></mat-spinner>
    </div>

    <ng-container *ngIf="shortlist?.length; else noNotifications">
      <div
        *ngFor="let notification of shortlist; index as notificationIndex; trackBy: trackByFn"
        class="notification-item"
        [class.not-read]="!notification.read"
        [class.not-clickable]="!notification.clickable">
        <a
          *ngIf="notification.linkParams"
          class="notification-with-link-params link-without-style"
          [routerLink]="notification.linkParams.linkParams"
          [queryParams]="notification.linkParams.extras?.queryParams">
          <ng-container
            [ngTemplateOutlet]="notificationContent"
            [ngTemplateOutletContext]="{ notification: notification }">
          </ng-container>
        </a>

        <div
          *ngIf="!notification.linkParams"
          class="notification-without-link-params"
          role="button"
          tabindex="0"
          [attr.aria-disabled]="!notification.clickable"
          [attr.aria-labelledby]="'notification-label-' + notification.id"
          (click)="notificationClick(notification, $event)">
          <ng-container
            [ngTemplateOutlet]="notificationContent"
            [ngTemplateOutletContext]="{ notification: notification }">
          </ng-container>
        </div>
      </div>
    </ng-container>
    <div *ngIf="loadingMore$ | async" class="loading-more" role="status" aria-live="polite">
      <span class="sr-only">
        {{ 'COMMON.LAYOUT.LOADING' | translate }}
      </span>

      <mat-spinner class="loading-more-spinner" [diameter]="35" [attr.aria-hidden]="true"></mat-spinner>
    </div>
    <div *ngIf="allNotificationsLoaded" class="no-more-notifications">
      <p>{{ 'IN_APP_NOTIFICATIONS.NO_MORE_NOTIFICATIONS' | translate }}</p>
    </div>
  </div>
  <ng-template #noNotifications>
    <div class="no-notifications-message">
      <h1>{{ 'IN_APP_NOTIFICATIONS.NO_NOTIFICATIONS' | translate }}</h1>
    </div>
  </ng-template>
</div>

<ng-template #notificationContent let-notification="notification">
  <button
    class="row content-row"
    type="button"
    (click)="notificationClick(notification, $event)"
    [attr.aria-labelledby]="'notification-label-' + notification.id"
    [matTooltip]="
      !notification.clickable
        ? ('IN_APP_NOTIFICATIONS.YOU_CANT_SEE_DETAILS_BECAUSE_WRONG_PROCESS_STATUS'
          | translate
            : {
                foreignerName: notification.foreignerName,
                document: notification.relatedUserDocument?.document,
                relatedUserProcess: notification.relatedUserProcess
              })
        : null
    "
    matTooltipClass="universalTooltip"
    [matTooltipDisabled]="notification.clickable || myself?.role?.key !== ROLES_KEYS.Foreigner"
    matTooltipPosition="left">
    <!-- LABEL FOR SCREEN READER -->
    <div [id]="'notification-label-' + notification.id" class="sr-only">
      {{
        'IN_APP_NOTIFICATIONS.' + notification.type
          | translate
            : {
                foreignerName: notification.foreignerName,
                document: notification.relatedUserDocument?.document,
                documentName: notification.documentName,
                relatedUserProcess: notification.relatedUserProcess,
                origError: notification.origError,
                externalSystemName: notification.data?.additionalInfo?.mergingJobOpts?.externalSystemName || null,
                signingDate: notification.data?.additionalInfo?.signingDate,
                signingMode: notification.data?.additionalInfo?.signingMode,
                additionalInfo: notification.data?.additionalInfo
              }
          | stripHtml
      }}
    </div>

    <!-- NOTIFICATIONS -->
    <div
      [ngSwitch]="notification.type"
      class="column column-icon"
      [class.multi-icons]="notification.type === InAppNotificationType.DOCUMENTS_SENT_TO_EXTERNAL_SYSTEM_AND_GENERATED">
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_SET_AVAILABILITY"
        class="foreigner-set-availability-icon">
        calendar_today
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_SENT_PRE_SURVEY_FOR_VERIFICATION"
        class="foreigner-sent-application-to-verification-icon">
        pending_actions
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_SENT_APPLICATION_TO_VERIFICATION"
        class="foreigner-sent-application-to-verification-icon">
        pending_actions
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_ADDED_DOCUMENT_COMMENT"
        class="foreigner-sent-message-in-chat-icon">
        mms
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.EMPLOYEE_ADDED_DOCUMENT_COMMENT"
        class="employee-sent-message-in-chat-icon">
        mms
      </mat-icon>
      <!-- <mat-icon *ngSwitchCase="InAppNotificationType.EMPLOYEE_CHANGED_DOCUMENT_STATUS"
                class="employee-changed-document-status-icon">
        description
      </mat-icon> -->
      <mat-icon
        *ngSwitchCase="InAppNotificationType.APPLICATION_STATUS_CHANGED"
        class="application-status-changed-icon">
        difference
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.APPLICATION_STATUS_CHANGED_WITH_TYPE"
        class="application-status-changed-icon">
        difference
      </mat-icon>
      <mat-icon *ngSwitchCase="InAppNotificationType.DOCUMENTS_LIST_CHANGED" class="documents-list-changed-icon">
        edit_document
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.DOCUMENTS_GENERATION_SUCCESS"
        class="documents-generation-success-icon">
        print
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.DOCUMENTS_SENT_TO_EXTERNAL_SYSTEM_AND_GENERATED"
        fontSet="material-icons-outlined"
        class="inpol-sending-success-icon">
        domain_verification
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.DOCUMENTS_SENT_TO_EXTERNAL_SYSTEM_AND_GENERATED"
        class="documents-generation-success-icon">
        print
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.DOCUMENTS_GENERATION_ERROR"
        class="documents-generation-error-icon">
        print_disabled
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.INPOL_SENDING_SUCCESS"
        fontSet="material-icons-outlined"
        class="inpol-sending-success-icon">
        domain_verification
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.INPOL_SENDING_ERROR"
        class="inpol-sending-error-icon material-icons-outlined">
        block
      </mat-icon>

      <mat-icon
        *ngSwitchCase="InAppNotificationType.MOS_SENDING_SUCCESS"
        fontSet="material-icons-outlined"
        class="inpol-sending-success-icon">
        domain_verification
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.MOS_SENDING_ERROR"
        class="inpol-sending-error-icon material-icons-outlined">
        block
      </mat-icon>

      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_MADE_PURCHASE"
        class="foreigner-made-purchase-icon material-icons-outlined">
        payments
      </mat-icon>

      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_HAS_BEEN_ASSIGNED_TO_YOU"
        class="foreigner-assigned-icon">
        person
      </mat-icon>
      <mat-icon *ngSwitchCase="InAppNotificationType.FOREIGNER_SENT_MESSAGE_IN_CHAT" class="new-chat-message-icon">
        forum
      </mat-icon>
      <mat-icon *ngSwitchCase="InAppNotificationType.EMPLOYEE_SENT_MESSAGE_IN_CHAT" class="new-chat-message-icon">
        forum
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_CHANGED_PERSONAL_DETAILS"
        class="changed-personal-details-icon">
        warning
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.EMPLOYEE_CANCELLED_VOIVODESHIP_OFFICE_APPOINTMENT"
        class="appointment-cancelled-icon">
        event_busy_outline
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.EMPLOYEE_CANCELLED_COMPANY_OFFICE_APPOINTMENT"
        class="appointment-cancelled-icon">
        event_busy_outline
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_SENDS_APPLICATION_WITH_POST"
        class="foreigner-sends-application-with-post">
        mark_as_unread
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_APPLICATION_MODE_HAS_CHANGED"
        class="objective-icon"
        fontSet="material-icons-outlined">
        priority_high
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.APPLICATION_MODE_CHANGED"
        class="inpol-sending-error-icon"
        fontSet="material-icons-outlined">
        integration_instructions
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_PICKED_SIGNING_MODE"
        class="new-chat-message-icon"
        fontSet="material-icons-outlined">
        draw
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_CHANGED_PLANNED_DOCUMENTS_SIGNING_MODE"
        class="changed-personal-details-icon"
        fontSet="material-icons-outlined">
        draw
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_CHANGED_PLANNED_DOCUMENTS_SIGNING_DATE"
        class="changed-personal-details-icon"
        fontSet="material-icons-outlined">
        calendar_month
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_PLANNING_TO_COME_TO_THE_OFFICE"
        fontSet="material-icons-outlined"
        class="primary-icon">
        calendar_month
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_SET_IMMIGRATION_OFFICE_VISIT_DATE"
        fontSet="material-icons-outlined"
        class="primary-icon">
        calendar_month
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_PLANNING_TO_COME_TO_OTHER_OFFICE"
        fontSet="material-icons-outlined"
        class="primary-icon">
        calendar_month
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_CHANGED_DATE_OF_COMPANY_OFFICE_VISIT"
        fontSet="material-icons-outlined"
        class="objective-icon">
        calendar_month
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_CHANGED_IMMIGRATION_OFFICE_VISIT_DATE"
        fontSet="material-icons-outlined"
        class="objective-icon">
        calendar_month
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_CHANGED_DATE_OF_OTHER_COMPANY_OFFICE_VISIT"
        fontSet="material-icons-outlined"
        class="objective-icon">
        calendar_month
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_CANCELLED_VISIT_IN_COMPANY_OFFICE"
        fontSet="material-icons-outlined"
        class="negative-icon">
        cancel
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_CANCELLED_VISIT_IN_OTHER_COMPANY_OFFICE"
        fontSet="material-icons-outlined"
        class="negative-icon">
        cancel
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_CONFIRMED_READINESS_FOR_VISIT"
        fontSet="material-icons-outlined"
        class="positive-icon">
        how_to_reg
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_CANCELLED_READINESS_FOR_VISIT"
        fontSet="material-icons-outlined"
        class="negative-icon">
        cancel
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.FOREIGNER_ADDED_ITEMS_TO_REVIEW"
        fontSet="material-icons-outlined"
        class="action-icon">
        attach_file_add
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.EMPLOYEE_CANCELLED_VISIT_IN_COMPANY_OFFICE"
        fontSet="material-icons-outlined"
        class="action-icon">
        event_busy_outline
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.NEW_FINAL_VERIFICATION_COMMENTS"
        fontSet="material-icons-outlined"
        class="action-icon">
        speaker_notes
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.CHANGED_FINAL_VERIFICATION_COMMENTS"
        fontSet="material-icons-outlined"
        class="action-icon">
        speaker_notes
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.REASSIGNED_FOREIGNERS_TO_YOU"
        fontSet="material-icons-outlined"
        class="action-icon">
        groups
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.NEW_APPLICATION_HAS_BEEN_ADDED"
        fontSet="material-icons-outlined"
        class="new-application-has-been-added-icon">
        post_add
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.NEW_APPLICATION_HAS_BEEN_ADDED_WITH_TYPE"
        fontSet="material-icons-outlined"
        class="new-application-has-been-added-icon">
        post_add
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.APPLICATION_HAS_BEEN_DELETED"
        fontSet="material-icons-outlined"
        class="application-has-been-removed">
        delete
      </mat-icon>
      <mat-icon
        *ngSwitchCase="InAppNotificationType.PARTNER_REQUESTED_PAYOUT"
        fontSet="material-symbols-outlined"
        class="action-icon">
        attach_money
      </mat-icon>
    </div>
    <div class="column column-text">
      <p
        class="text notification"
        [innerHTML]="
          'IN_APP_NOTIFICATIONS.' + notification.type
            | translate
              : {
                  foreignerName: notification.foreignerName,
                  document: notification.relatedUserDocument?.document,
                  documentName: notification.documentName,
                  relatedUserProcess: notification.relatedUserProcess,
                  origError: notification.origError,
                  externalSystemName: notification.data?.additionalInfo?.mergingJobOpts?.externalSystemName || null,
                  signingDate: notification.data?.additionalInfo?.signingDate,
                  signingMode: notification.data?.additionalInfo?.signingMode,
                  additionalInfo: notification.data?.additionalInfo
                }
            | sanitizeHtml
            | truncate: 140 : false
        "></p>
    </div>
    <div class="column column-read-indicator">
      <div
        *ngIf="loadingChangesIn !== notification.id; else showLoadingChanges"
        [matBadgeHidden]="!notification.stacked"
        matBadgePosition="before"
        matBadgeSize="medium"
        [matBadgeColor]="notification.read ? 'accent' : 'warn'"
        [matBadge]="notification.stackSize"
        class="unread-icon"
        [class.hide-dot]="notification.read || notification.stacked"></div>
      <ng-template #showLoadingChanges>
        <div class="loading-wrapper" role="status" aria-live="polite">
          <span class="sr-only">
            {{ 'COMMON.LAYOUT.LOADING' | translate }}
          </span>

          <mat-spinner [diameter]="15" [attr.aria-hidden]="true"></mat-spinner>
        </div>
      </ng-template>
    </div>
  </button>

  <div class="meta-wrapper">
    <button
      *ngIf="!notification.read"
      class="action-button"
      type="button"
      (click)="$event.stopPropagation(); $event.preventDefault(); markAsRead(notification)">
      {{ 'IN_APP_NOTIFICATIONS.MARK_AS_READ' | translate }}
    </button>
    <button
      *ngIf="notification.read"
      class="action-button"
      type="button"
      (click)="$event.stopPropagation(); $event.preventDefault(); markAsUnread(notification)">
      {{ 'IN_APP_NOTIFICATIONS.MARK_AS_UNREAD' | translate }}
    </button>
    <p class="date">{{ notification.createdAt | date: 'dd-MM-yyyy HH:mm' }}</p>
  </div>
</ng-template>
